import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Section from '../../section';
import Container from '../../container';
import TextWave from '../../text-wave';
import HomeH3 from '../HomeH3';
import Subhead from '../../subhead';
import ProgramGrid from '../../program-grid';
import RenderMd from '../../render-md';

const Programs = ({ subheading, title, copy, programList }) => (
  <Section dark>
    <Container>

      <Subhead>{subheading}</Subhead>

      <TextWave>
        <HomeH3>{title}</HomeH3>
      </TextWave>

      {copy &&
        <SupportingCopy>
          <RenderMd source={copy} />
        </SupportingCopy>
      }

      <ProgramGrid
        programList={programList}
        lazyLoad
      />

    </Container>
  </Section>
);

const SupportingCopy = styled.div`
  max-width: 800px;
  margin: 40px auto auto;
  text-align: center;
`;

Programs.propTypes = {
  subheading: PropTypes.string,
  title: PropTypes.string,
  copy: PropTypes.string,
  programList: PropTypes.arrayOf(PropTypes.object),
};

export default Programs;
